import { render, staticRenderFns } from "./SanctionAssignedUpdate.vue?vue&type=template&id=255647f9"
import script from "./SanctionAssignedUpdate.vue?vue&type=script&lang=js"
export * from "./SanctionAssignedUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports